import { AfterViewInit, ChangeDetectorRef, Component, OnInit, signal } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import * as BUTTON_CONFIG from '../../../../../constants/button/index';
import { TimesheetType } from '../../../../../constants/lookup/timesheet/timesheet-type.enum';
import { API_METHOD_CONSTANTS } from '../../../../../constants/ngrx-store/core';
import { SCHEDULE_METHOD_CONSTANT } from '../../../../../constants/ngrx-store/schedule';
import { CommonUtil } from '../../../../../core/utils/common-util';
import { ScheduleStoreService } from '../../../../../state/modules/schedule/schedule-store.service';
import { TimesheetStoreService } from '../../../../../state/modules/timesheet/timesheet-store.service';
import { ModalBaseClass } from '../../../../shared/components/modals/base_class/modal-base-class';
import { AddShiftTaskGroupComponent } from '../add-shift-task-group/add-shift-task-group.component';
import { TaskGroupListActionComponent } from '../task-group-list-action/task-group-list-action.component';
import { ShiftStatus } from '../task-group-list-action/task-group-list-action.constant';

@Component({
  standalone: false,
  selector: 'kt-task-group-list',
  templateUrl: './task-group-list.component.html',
  styleUrls: ['./task-group-list.component.scss'],
})
export class TaskGroupListComponent extends ModalBaseClass implements OnInit, AfterViewInit {
  buttonConfig = BUTTON_CONFIG;
  shiftTimesheetInfo = null;
  tasks = null;
  isUncsheduled = false;
  timesheet = null;
  location = { latitude: CommonUtil.Latitude, logitude: CommonUtil.Longitude };
  activeTaskGroup = null;
  viewMode = false;
  user_id = 0;
  currentStatus;
  shiftStatusEnum = ShiftStatus;
  loading = signal(false);

  constructor(private ngbModal: NgbModal, public activeModal: NgbActiveModal, private timesheetStoreService: TimesheetStoreService, private scheduleStoreService: ScheduleStoreService, private cdr: ChangeDetectorRef) {
    super(ngbModal);
  }

  ngOnInit() {
    if ((!(this.shiftTimesheetInfo && this.shiftTimesheetInfo.location && this.shiftTimesheetInfo.location.location_timesheet_allow_start_shift_via_web_browser_enable)) || !this.timesheet) {
      this.viewMode = true;
    }
  }

  ngAfterViewInit(): void {
    // Accordion shim wires panel.accordion one CD cycle late; with static modal
    // `tasks` and no ambient tick the panels' *ngIf="accordion" never paints.
    // Force the second pass so the task list renders.
    this.cdr.detectChanges();
  }

  taskGroupFillHandler(actualTask, data) {
    this.loading.set(false);
    // console.log(data);
    if (data.success && data.data.data.task_group && data.data.data.task_group) {
      const  task = data.data.data.task_group;
      const componetRef = this.openPopUp(TaskGroupListActionComponent, {currentStatus: this.currentStatus, task, user_id: this.user_id, shiftTimesheetInfo: this.shiftTimesheetInfo, isUncsheduled: this.isUncsheduled, taskGroupListDetail: this.activeTaskGroup, timesheet: this.timesheet, viewMode: actualTask || (!this.timesheet) || (!(this.shiftTimesheetInfo && this.shiftTimesheetInfo.location && this.shiftTimesheetInfo.location.location_timesheet_allow_start_shift_via_web_browser_enable)) ? true : false }, { centered: true, size: 'lg', backdrop: 'static' });
      componetRef.result.then(res => {
        // if (res.reload) {
          this.activeModal.close({ reopen: true });
        // }
      });
    }
  }

  addClickHandler() {
    const componetRef = this.openPopUp(AddShiftTaskGroupComponent, { user_id: this.user_id, shiftTimesheetInfo: this.shiftTimesheetInfo, isUncsheduled: this.isUncsheduled, taskGroupListDetail: this.activeTaskGroup, timesheet: this.timesheet  }, { centered: true, size: 'lg', backdrop: 'static' });
    componetRef.result.then(res => {
      if (res.reload) {
        this.activeModal.close({ reopen: true });
      }
    });
  }

  taskGroupEditClickHandler(event, task, actualTask = null) {
    event.stopPropagation();
    if (this.loading()) {
      return;
    }
    this.activeTaskGroup = task;
    this.dispatchTaskGroupDetail(actualTask);
  }

  getTaskGroupDetail(actualTask = null) {
    return {
      type: this.activeTaskGroup &&  this.activeTaskGroup.shift_task_group_id ? TimesheetType.SHIFT : TimesheetType.TIMESHEET,
      shift_task_group_id: this.activeTaskGroup ? this.activeTaskGroup.shift_task_group_id : 0,
      location_task_group_id: this.activeTaskGroup ?   this.activeTaskGroup.location_task_group_id : 0,
      task_group_id: this.activeTaskGroup ?  this.activeTaskGroup.task_group_id : 0,
      timesheet_log_id: actualTask ? actualTask.timesheet_log_id : 0,
      timesheet_task_group_id: this.activeTaskGroup &&  this.activeTaskGroup.actual_task_group_new && this.activeTaskGroup.actual_task_group_new.length ? this.activeTaskGroup.actual_task_group_new[0].timesheet_task_group_id : actualTask ? actualTask.timesheet_task_group_id : 0 ,
    };
  }

  dispatchTaskGroupDetail(actualTask = null) {
    this.loading.set(true);
    this.scheduleStoreService.dispatchScheduleCommon({
      module: SCHEDULE_METHOD_CONSTANT.GET_TASK_GROUP_DETAIL,
      method: API_METHOD_CONSTANTS.GET_ALL_WITH_PARAMETERS,
      data: this.getTaskGroupDetail(actualTask),
      callback: this.taskGroupFillHandler.bind(this, actualTask),
    });
  }


}
